var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { v4 as uuid } from 'uuid';
import { batch } from 'react-redux';
import { getSocketIfExist } from '../../utils/getSocket';
import { setSearchValue, getSearchValueFromString } from '../../utils/http';
import { conversations } from '../../services/api/scribe';
import { getOS } from '../../utils';
import { isDefaultRoomId, sendResetRoomIdMessage, sendMbackendMessage } from '../../utils/ws-v1';
import { updateRoomId, log } from '../../utils/log';
import { fetchRemainingCredits, setLoadingApp } from '../session';
import { setIsRestartingMicrophone } from '../audio-recorder';
import ConversationActionTypes from '../../action-types/conversation';
export function closeConnection() {
    return (dispatch) => {
        dispatch({ type: 'CLOSE_SCRIBE_SESSION_WINDOW' });
    };
}
const handleMicChangeMac = (state, newMicId, notifyInternalAudio) => {
    const { isInConversation } = state.scribeSession;
    if (window.isElectron && getOS() === 'Mac' && isInConversation) {
        const { availableMics, micIdSelected, status: { participants }, } = state.scribeConversation;
        const oldMic = micIdSelected && availableMics.find((m) => m.value === micIdSelected);
        const newMic = availableMics.find((m) => m.value === newMicId);
        const oldMicInternal = oldMic && oldMic.label.startsWith('Ava Computer Audio');
        const newMicInternal = newMic && newMic.label.startsWith('Ava Computer Audio');
        const shouldActiveMacInternalAudio = !oldMicInternal && newMicInternal;
        const conversationParticipants = participants || [];
        const shouldDeactivateMacInternalAudio = (oldMicInternal && !newMicInternal) || conversationParticipants.length > 1;
        if (shouldActiveMacInternalAudio) {
            window.electronIPC.sendActivateMacInternalAudio();
            if (notifyInternalAudio) {
                notifyInternalAudio();
            }
        }
        else if (shouldDeactivateMacInternalAudio) {
            window.electronIPC.sendDeactivateMacInternalAudio();
        }
    }
};
export const setMicSelected = (micId, notifyInternalAudio) => {
    return (dispatch, getState) => {
        log('setMicSelected', 'info', { micId });
        const state = getState();
        dispatch({
            type: 'SET_MIC_ID',
            micId,
        });
        handleMicChangeMac(state, micId, notifyInternalAudio);
    };
};
export const setOnlyInternalAudio = (value) => {
    return (dispatch) => {
        dispatch({
            type: 'SET_ONLY_INTERNAL_AUDIO',
            value,
        });
    };
};
export const setAvailableMics = (mics) => {
    log('setAvailablesMics', 'info', { mics });
    return {
        type: 'SET_AVAILABLE_MICS',
        mics,
    };
};
export const setLangSelected = (lang) => {
    log('setSpeechLang', 'info', { lang });
    return {
        type: 'SET_SPEECH_LANG',
        lang,
    };
};
export function startRecord() {
    return (dispatch) => {
        log('microphoneIsOn', 'info', { value: 'true' });
        dispatch({ type: 'START_RECORD' });
    };
}
export function stopRecord() {
    return (dispatch) => {
        dispatch({ type: 'STOP_RECORD' });
        setTimeout(() => {
            // The 'mute' message is sent to the backend with a delay, because
            // if any audio packet is sent after 'mute', then the backend
            // will try to reset audio recording with 'reset-recorder' message
            // (see the function 'startConversationReadClient' below).
            // However, resetting audio recorder means it will start recording again.
            // So, it can happen that 'stopRecord()' sometimes doesn't really stop
            // recording.
            //
            // The delay here gives audio recorder time  to gracefully
            // shutdown all the streams.
            const socket = getSocketIfExist();
            if (socket) {
                sendMbackendMessage(socket, {
                    type: 'mute',
                });
            }
        }, 500);
        log('microphoneIsOn', 'info', { value: 'false' });
    };
}
export function closeWebsocketConnection() {
    return (dispatch, getState) => new Promise((resolve) => {
        if (!getState().scribeSession.url) {
            dispatch({ type: 'CLOSE_SCRIBE_SESSION_WINDOW' });
            resolve();
            return;
        }
        const socket = getSocketIfExist();
        dispatch({ type: 'CLEAN_APP' });
        if (socket) {
            socket.close();
        }
        dispatch({ type: 'CLOSE_SCRIBE_SESSION_WINDOW' });
        resolve();
    });
}
export const rejectScribeConversationRequest = () => ({
    type: 'REJECT_SCRIBE_CONVERSATION_REQUEST',
});
export const clearScribeConversationState = () => ({
    type: 'CLEAR_SCRIBE_CONVERSATION',
});
export const clearScribeSessionState = () => ({
    type: 'CLEAR_SCRIBE_SESSION',
});
// Returns [batchDispatchFn, cancelFn]
export const makeBatchDispatcher = (dispatch) => {
    const actionsToDispatch = [];
    const batchedDispatch = (action) => {
        actionsToDispatch.push(action);
    };
    const dispatchAllActions = () => {
        batch(() => {
            actionsToDispatch.forEach(dispatch);
            actionsToDispatch.splice(0, actionsToDispatch.length);
        });
    };
    const interval = setInterval(dispatchAllActions, 250);
    return [
        batchedDispatch,
        () => {
            dispatchAllActions();
            clearInterval(interval);
        },
    ];
};
export const handleNewRoomStatus = (status, force) => {
    return (dispatch, getState) => {
        if (status.id && !isDefaultRoomId(status.id)) {
            const rwLink = (status.links || {}).rw;
            const token = getSearchValueFromString(rwLink.split('?')[1], 'token', undefined);
            if (token) {
                setSearchValue(window, 'token', token);
            }
            const endpoint = getSearchValueFromString(rwLink.split('?')[1], 'endpoint', undefined);
            if (endpoint) {
                setSearchValue(window, 'endpoint', endpoint);
            }
            // Check if current user is scribe
            const state = getState();
            if (status &&
                status.participants &&
                state &&
                state.scribeSession &&
                state.scribeSession.captioner &&
                state.scribeSession.captioner.avaId &&
                status.participants.some(({ scribe, avaId }) => scribe && avaId === state.scribeSession.captioner.avaId)) {
                setSearchValue(window, 'scribe', '1');
            }
        }
        updateRoomId(status.id);
        log('websocketMessage', 'info', {
            message: status,
            direction: 'b2f',
        });
        dispatch({
            type: 'ROOM_STATUS_UPDATE',
            status,
            force,
        });
    };
};
export function startConversationReadClient() {
    return (dispatch, getState) => {
        const socket = getSocketIfExist();
        if (!socket) {
            dispatch({ type: 'LOST_WEB_SESSION_CONNECTION' });
            dispatch({ type: 'SET_NOT_LOADED' });
            return;
        }
        dispatch({
            type: 'ACCEPT_SCRIBE_CONVERSATION_REQUEST',
        });
        let loadedAudio;
        let connectionSucceded;
        const [batchedDispatch, cancelBatchDispatch] = makeBatchDispatcher(dispatch);
        const currentConversationListener = (event) => {
            const message = JSON.parse(event.data);
            if (message.type === 'transcript-edit') {
                const { mutation, origin, transcriptId, speakerId } = message.data;
                batchedDispatch({
                    type: 'RECEIVED_SCRIBE_CONVERSATION_TRANSCRIPT_MUTATION',
                    mutation,
                    origin,
                    transcriptId,
                    speakerId,
                });
                if (mutation && mutation.parent === 'lucy') {
                    log('mutationReceived', 'info', {
                        message,
                    });
                }
                if (!connectionSucceded) {
                    connectionSucceded = true;
                    dispatch({ type: 'SET_LOADED' });
                }
            }
            else if (message.type === 'audio' && !loadedAudio) {
                dispatch({ type: 'SET_LOADED' });
                loadedAudio = true;
            }
            else if (message.type === 'room-status-update' || message.type === 'room-status') {
                batchedDispatch(handleNewRoomStatus(message, true));
            }
            else if (message.type === 'reset-recorder') {
                // Backend wants to reset recording. This can happen for
                // different reasons, most common one is that an audio packet
                // is sent by us after we've muted the mic.
                // See 'stopRecord()' function above.
                const { audioRecorder: { hasMicrophoneRestarted, isRestartingMicrophone }, } = getState();
                // To prevent multiple actions from dispatching, we only restart the
                // microphone if it is not in the process of doing so already.
                if (!hasMicrophoneRestarted && !isRestartingMicrophone) {
                    dispatch(setIsRestartingMicrophone(true));
                }
            }
            else if (message.type === 'connection-succeeded') {
                connectionSucceded = true;
                dispatch({
                    type: 'CONNECTION_SUCCEEDED',
                    status: message.hash,
                    reconnectionWsUrl: message.reconnectionWsUrl,
                });
                const interval = setInterval(() => {
                    const { scribeConversation: { loaded, lastMutationReceivedTimestampMs }, } = getState();
                    if (loaded || Date.now() - lastMutationReceivedTimestampMs > 1500) {
                        clearInterval(interval);
                        dispatch({ type: 'SET_LOADED' });
                    }
                }, 1000);
            }
        };
        socket.addEventListener('message', currentConversationListener);
        socket.addEventListener('close', () => {
            cancelBatchDispatch();
            dispatch({ type: 'LOST_WEB_SESSION_CONNECTION' });
            dispatch({ type: 'SET_NOT_LOADED' });
        });
    };
}
export const scribeTagConversation = (tags) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    // 03/24, this is currently not callable from the UI and most likely does not
    // work, but was deemed necessary to keep. Ask @skinner.
    const { id, conversationStarted } = getState().scribeConversation;
    if (!conversationStarted)
        return;
    try {
        yield conversations.tagConversation({
            id: id.replace('conversations:', ''),
            tags,
        });
        dispatch({
            type: 'SCRIBE_CONVERSATION_TAGGED',
            tags,
        });
    }
    catch (err) {
        const { response } = err;
        if (response && response.status === 403) {
            // eslint-disable-next-line no-alert
            alert('It seems that your are not authorized to perform this action. Please contact adrien@ava.me for more informations');
        }
        else {
            // eslint-disable-next-line no-alert
            alert('Something went wrong!');
        }
        throw err;
    }
});
export const switchLang = (lang) => ({ type: 'SWITCH_LANG', lang });
export const updateKeyboardInputShown = (value) => {
    log('updateKeyboardInputShown', 'info', { value });
    return {
        type: 'SHOW_OR_HIDE_NEW_TRANSCRIPT_INPUT',
        value,
    };
};
export const enterInsertSpeakerNameMode = () => ({
    type: 'ENTER_INSERT_SPEAKER_NAME_MODE',
});
export const exitInsertSpeakerNameMode = () => ({
    type: 'EXIT_INSERT_SPEAKER_NAME_MODE',
});
export const enterUpdateAudioSourceMode = () => ({
    type: 'ENTER_UPDATE_AUDIO_SOURCE_MODE',
});
export const exitUpdateAudioSourceMode = () => ({
    type: 'EXIT_UPDATE_AUDIO_SOURCE_MODE',
});
export const createNewConversation = (options) => (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
    const ws = getSocketIfExist();
    if (!ws) {
        dispatch({ type: 'LOST_WEB_SESSION_CONNECTION' });
        dispatch(setLoadingApp(false));
        return;
    }
    // NOTE: We know that the WebSocket exists, BUT - it might already be in invalid
    // state and might close while we `await` something. That's why it's important
    // to setLoadingApp to false, so that SocketReconnector can get instantiated
    // and recreate the socket (it does not get instantiated while loadingApp is
    // true!). It's a mess. Please fix. Fixing will require redesigning how he handle
    // the websocket life.
    // This hack will still mean that createNewConversation will fail if the socket
    // is in an invalid state. But at least it will succeed the second time, rather
    // than third!
    const cache = { listener: undefined, closeListener: undefined };
    cache.closeListener = () => {
        if (cache.listener)
            ws.removeEventListener('message', cache.listener);
        if (cache.closeListener)
            ws.removeEventListener('close', cache.closeListener);
        dispatch(setLoadingApp(false));
    };
    ws.addEventListener('close', cache.closeListener);
    const { scribeSession: { captioner: user }, } = getState();
    // Purposefully ignoring promise, as we only care about side effects.
    fetchRemainingCredits(user.avaId)(dispatch);
    const roomId = (options && options.roomId) || `${user.avaId}_${uuid()}`;
    const inConferenceCall = options && options.inConferenceCall;
    dispatch({ type: 'CREATE_NEW_CONVERSATION', roomId, inConferenceCall });
    cache.listener = (message) => {
        const data = JSON.parse(message.data);
        if (data.type === 'room-status' && data.id === roomId) {
            ws.removeEventListener('message', cache.listener);
            ws.removeEventListener('close', cache.closeListener);
        }
    };
    ws.addEventListener('message', cache.listener);
    sendResetRoomIdMessage(ws, roomId);
});
if (window.isElectron) {
    window.electronIPC.onCreateNewConversation(() => __awaiter(void 0, void 0, void 0, function* () {
        window.store.dispatch(createNewConversation({}));
    }));
}
export const updateBroadcastToZoomToken = (token) => ({
    type: 'UPDATE_BROADCAST_TO_ZOOM_TOKEN',
    token,
});
export const setCurseFilter = (value) => ({
    type: 'SET_CURSE_FILTER',
    value,
});
export const addEditedWord = (word, transcriptionId) => ({
    type: 'ADD_EDITED_WORD',
    payload: { text: word, transcriptionId },
});
// Clicking on the add participant icon will show open up a panel where the user
// can copy a link to their room or join another conversation.
export const setInviteCardOpen = (isOpen) => ({
    type: ConversationActionTypes.SET_INVITE_CARD_OPEN,
    payload: isOpen,
});
// Indicates the status of joining a conversation. This is
// triggered through typing in an Ava room in the invite card.
export const setJoiningStatus = (joiningStatus) => ({
    type: ConversationActionTypes.SET_JOINING_STATUS,
    payload: joiningStatus,
});
